<!-- 修改登录密码 -->
<template>
    <div class="dark main-box">
        <div class="content-main">
            <div class="top-info">
                <a-button class="back-btn" @click="goBack">
                    <template #icon>
                        <icon-left/>
                    </template>
                </a-button>
                <span>{{ $t('personal.change_login_password') }}</span>
            </div>
            <div class="recommendInvite-content">
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.old_password') }}</span></div>
                    <a-input-password class="input" :placeholder="$t('personal.old_password_placeholder')" allow-clear long/>
                </div>
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.new_password') }}</span></div>
                    <a-input-password class="input" :placeholder="$t('personal.new_password_placeholder')" allow-clear long/>
                </div>
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.confirm_new_password') }}</span></div>
                    <a-input-password class="input" :placeholder="$t('personal.confirm_new_password_placeholder')" allow-clear long/>
                </div>
                <div class="recommendInvite-content-box">
                    <a-button class="confirm" @click="handleOk">{{ $t('personal.confirm') }}</a-button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'changePhone',
    components: {},
    data() {
        return {};
    },
    methods: {
        goBack() {
            this.$emit("safet-event");
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./changePassword.scss";

</style>